import React, { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from 'modules/views/shared/Modal';
import Select from 'modules/views/shared/Select';
import { useStyles } from './styles';

interface Company {
  id: string;
  name: string;
  companyLabel: number;
  isUserAWorkerInCompany: boolean;
  companyUserId: string;
  companyUserType: number;
  isVerified: boolean;
}

interface CompanySelectionModalProps {
  companies: Company[];
  isVisible: boolean;
  isLoading?: boolean;
  onSelectCompany: (companyId: string) => void;
  onClose: () => void;
}

const CompanySelectionModal = ({
  companies,
  isVisible,
  isLoading = false,
  onSelectCompany,
  onClose,
}: CompanySelectionModalProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [selectedCompany, setSelectedCompany] = useState<any>(null);

  const companyOptions = companies.map(company => ({
    value: company.id,
    label: company.name,
  }));

  const handleConfirm = () => {
    if (selectedCompany) {
      onSelectCompany(selectedCompany.value);
    }
  };

  const Content = (
    <Select
      inputLabel={t('login.selectCompany')}
      options={companyOptions}
      selectedValue={selectedCompany}
      onChange={setSelectedCompany}
      required={true}
      testId="company-select"
    />
  );

  return (
    <Modal
      title={t('login.multipleCompaniesTitle')}
      Content={Content}
      isVisible={isVisible}
      modalStyleClass={classes.companySelectionModal}
      disableBackdropClose={true}
      actionButtons={[
        {
          label: t('common.confirm'),
          onClick: handleConfirm,
          disabled: !selectedCompany || isLoading,
          isLoading: isLoading,
          styleClass: classes.companySelectionModalButton,
          testId: 'company-confirm-button',
        },
      ]}
      onClose={onClose}
    />
  );
};

export default memo(CompanySelectionModal);
